import React, { useState } from 'react';
import { Modal } from 'antd-mobile';
import Stores from 'config/Stores';
import config from 'config/Config';

let showModalFn;

const ToWeapp = () => {
  const [visible, setVisible] = useState(false);
  const [jumpType, setJumpType] = useState(1);
  const [modal_mini_image, setModal_mini_image] = useState('');
  const [envVersion, setEnvVersion] = useState('release');
  const [path, setPath] = useState('');
  const [username, setUsername] = useState('');
  let callBack = null;

  showModalFn = (params) => {
    setVisible(true);
    setModal_mini_image(params.icon || ''); // 图标
    setEnvVersion(params.envVersion || 'release');
    setPath(params.path || '');
    setUsername(params.username || '');
    callBack = params.callBack || null;
  };

  const { token } = Stores.AppMod;
  if (!visible || !token) {
    return null;
  }

  return (
    <Modal
      title=""
      wrapClassName="posterModal"
      transparent
      visible={visible}
      maskClosable
      onClose={() => setVisible(false)}>
      <div className="weappModal">
        <div>
          <wx-open-launch-weapp
            id="launch-btn"
            username={username}
            path={path}
            env-version={envVersion}>
            <script type="text/wxtag-template">
              <img src={modal_mini_image} style={{ width: '540px', height: 'auto' }} />
            </script>
          </wx-open-launch-weapp>
        </div>
        <img
          style={{ width: '65px', marginTop: '58px' }}
          src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
          onClick={() => {
            setVisible(false);
            callBack && callBack();
          }}
        />
      </div>
    </Modal>
  );
};

export const showToWeapp = (params) => {
  if (showModalFn) {
    showModalFn(params);
  }
};

export default ToWeapp;



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/ToWeapp/index.js